import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import { Navbar } from './Components';
import routes from './routes';
import { ANALYTICS_EVENTS, trackAnalyticsEvent } from './services/analytics';

const RouteAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        trackAnalyticsEvent(ANALYTICS_EVENTS.PAGE_VIEW, {
            page_path: `${location.pathname}${location.search}`,
            page_location: window.location.href,
            page_title: document.title || 'Tune',
        });
    }, [location.pathname, location.search]);

    return null;
};

function App() {
    return (
        <div className="App">
            <RouteAnalytics />
            <Navbar />
            <Routes>
                {routes.map(({ path, element }) => (
                    <Route key={path} path={path} element={element} />
                ))}
            </Routes>
        </div>
    );
}

export default App;
